import { InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { Company, IAction } from '@ztechapps/common.contract'

@InputType()
export class GetMySchoolArgs extends ActionArgs {}

export interface IGetMySchool extends IAction<Company | null, GetMySchoolArgs> {}
